import OrderStore from '../stores/OrderStore';
import ModalActions from '../actions/ModalActions';
import OrderService from '../services/OrderService';
import AppDispatcher from '../dispatcher/AppDispatcher';
import { ActionTypes, GlobalModals } from '../constants/AppConstants';
import {
    TooManyTicketsError,
    InvalidOrderStateError,
    NotEnoughAvailabilityError,
    DiscountCodeError,
    InteropError
} from '../errors/Order';
import { handleUnauthorisedError } from './Customer';
import { updateOrderCookie } from '../utils/orderUtils';
import PassengerAssistActions from '../actions/PassengerAssistActions';
import PassengerAssistStore from '../stores/PassengerAssistStore';


export function checkOrderExpiry (target, name, descriptor) {
    const original = descriptor.value;
    descriptor.value = function () {
        const currentOrder = OrderStore.getCurrent();
        if (currentOrder && currentOrder.hasExpired()) {

            if (currentOrder.hasRecentlyExpired()) {
                OrderService.delete(currentOrder)
                    .catch(e => { console.warn(`delete expired order`, e); });

                return ModalActions.open(GlobalModals.BASKET_EXPIRED, {
                    order: currentOrder,
                    onClose: () => {
                        AppDispatcher.dispatch({ actionType: ActionTypes.ORDER_EXPIRED });
                        ModalActions.close(GlobalModals.BASKET_EXPIRED);
                    }
                });
            }

            updateOrderCookie({});
            AppDispatcher.dispatch({ actionType: ActionTypes.ORDER_EXPIRED });
        }
        return original.apply(this, arguments);
    };
    descriptor.value.__DECORATORS = ['checkOrderExpiry'].concat(original.__DECORATORS || []); // for unit tests
    return descriptor;
}

function handleOrderError(error) {
    switch (true) {
        case (error instanceof TooManyTicketsError):
            ModalActions.open(GlobalModals.ERROR, {
                message: 'basket.error.tripsLimit',
                customButton: {
                    text: 'ariaLabel.openBasket',
                    onClick: ModalActions.open.bind(null, GlobalModals.BASKET)
                }
            });
            return false;
        case (error instanceof InvalidOrderStateError):
            ModalActions.open(GlobalModals.ORDER_STATE_ERROR);
            return false;
        case (error instanceof NotEnoughAvailabilityError):
            ModalActions.open(GlobalModals.ERROR, {
                message: 'basket.error.noAvailability'
            });
            return false;
        case (error instanceof DiscountCodeError):
            ModalActions.open(GlobalModals.ERROR, {
                message: 'basket.error.discountCode'
            });
            return false;
        case (error instanceof InteropError):
                ModalActions.open(GlobalModals.INTEROP_ERROR);
                return false;
        default:
            return handleUnauthorisedError(error);
    }
}

export function handleOrderErrors (target, name, descriptor) {
    const original = descriptor.value;
    descriptor.value = async function () {
        try {
            const result = await original.apply(this, arguments);
            return result;
        } catch (error) {
            return handleOrderError(error);
        }
    };
    descriptor.value.__DECORATORS = ['handleOrderErrors'].concat(original.__DECORATORS || []); // for unit tests
    return descriptor;
}

export function setOrderDataCookie (target, name, descriptor) {
    const original = descriptor.value;
    descriptor.value = async function () {
        const result = await original.apply(this, arguments); // call the original logic first and then execute this descriptor logic.
        updateOrderCookie();
        return result;
    };
    descriptor.value.__DECORATORS = ['setOrderDataCookie'].concat(original.__DECORATORS || []); // for unit tests
    return descriptor;
}

export function deleteMatchingPassengerAssistRequests(target, name, descriptor) {
    const original = descriptor.value;
    descriptor.value = async function (...args) {
        const [, orderTrip] = args;
        const outwardJourney = orderTrip.getOutwardJourney();
        const returnJourney = orderTrip.getReturnJourney();

        // Find and delete any matching Passenger Assist requests
        const passengerAssistRequests = PassengerAssistStore.getPendingPassengerAssistRequests();

        if (passengerAssistRequests) {
            let matchingRequest = passengerAssistRequests.find(req => req.orderTripId === orderTrip.id);

            const {
                outwardEnabled,
                returnEnabled
            } = matchingRequest || {};

            let hasMatchingPAJourney = false;

            if (outwardJourney) {
                hasMatchingPAJourney = outwardEnabled;
            } else if (returnJourney) {
                hasMatchingPAJourney = returnEnabled;
            }

            if (hasMatchingPAJourney) {
                PassengerAssistActions.deleteTravelAssist(matchingRequest);
            }
        }

        return original.apply(this, args);
    };
    descriptor.value.__DECORATORS = ['deleteMatchingPassengerAssistRequests'].concat(original.__DECORATORS || []); // for unit tests
    return descriptor;
}
